module.exports = __webpack_public_path__ + "img/location-confirm.fd8afb24.jpg";